import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({
  breakpoints: {
    values: { sm }
  },
  palette: {
    grey: { G200 },
    primary: { light }
  },
  spacing: { unit }
}: ComposedTheme) => ({
  articleContainer: {
    width: '100%'
  },
  article: {
    margin: [0, 'auto'],
    minHeight: '100vh',
    overflow: 'auto',
    paddingTop: unit * 5,
    width: 341,
    [`@media only screen and (max-width: ${sm}px)`]: {
      width: 'initial'
    }
  },
  login: {
    border: `3px solid ${light || 'transparent'}`,
    minWidth: 335,
    padding: unit * 4,
    width: '100%',
    backgroundColor: G200
  },
  loginButton: {
    borderRadius: 4
  },
  loginForm: {
    padding: `${unit * 2}px 0`,
    backgroundColor: G200,
    '& fieldset': {
      margin: 0
    }
  }
});

export default createUseStyles(styles);
